import { ESSENTIALS_CONTENT_CATEGORY } from '../../essentials/types'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** CIS Injustice toolkit */
export const cisInjusticeToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.CIS_INJUSTICE,
  iFrameSrcUrl: '/injustice-cis-toolkit',
  micrositeUrl: 'injustice-cis-toolkit',
  title: {
    id: 'cisInjustice.title',
    defaultMessage: 'Injustice CIS toolkit',
    description: 'Microsite page title',
  },
  featureFlag: 'nov2025ToolkitsEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
      params: {
        category: ESSENTIALS_CONTENT_CATEGORY.TOPIC,
        slug: 'coping-with-crisis',
      },
    },
  ],
  page: 'CIS injustice',
  trackUTMParams: {
    utm_campaign: 'CISinjustice',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'CISinjustice',
  },
  shouldHideForInternational: true,
}
